import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { PaymentService } from '@core/api/payment.service';
import { PaymentPeriod, Site } from '@shared/models';

export interface DialogData {
  line1: string;
  periods: PaymentPeriod[];
  sites: Site[];
  showList: boolean;
  alreadyPaid: number;
  calcs: any;
}

@Component({
    selector: 'fc-dialog-confirm-payment',
    templateUrl: './dialog-confirm-payment.component.html',
    styleUrls: ['./dialog-confirm-payment.component.scss'],
    standalone: false
})
export class DialogConfirmPaymentComponent {
  payPeriod: PaymentPeriod = null;
  alreadyPaid: number = null;
  title: string = 'PAY SITE';
  calcs: any = null;
  balance: number = 0;

  constructor(
    public dialogRef: MatDialogRef<DialogConfirmPaymentComponent>,
    readonly paymentService: PaymentService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    if (data.alreadyPaid !== null) {
      this.alreadyPaid = data.alreadyPaid;
    }
    if (data.calcs) {
      this.calcs = data.calcs;
    }
    this.paymentService.getStripeBalance().subscribe(response => {
      this.balance = response;
    });
  }

  changePayPeriod(event: any): void {
    this.payPeriod = this.data.periods.find(p => p.id === event.value);
    this.alreadyPaid = 0;

    this.calcs = {
      payments: [],
      totalPaid: 0.0,
    };
    for (const site of this.data.sites) {
      const payment = site.paymentPeriods.find(
        p => p.startDate === this.payPeriod.startDate && p.endDate === this.payPeriod.endDate && (p.reportId != null || p.reportResponseId != null)
      );
      if (payment) {
        if (payment.paymentId === null) {
          this.calcs.totalPaid += payment.netPayout;
          this.calcs.payments.push({
            site,
            name: site.name,
            amount: payment.netPayout,
          });
        } else {
          this.alreadyPaid += 1;
        }
      }
    }
    this.data.line1 = '';
  }

  onYesClick(): void {
    this.dialogRef.close({
      payPeriod: this.payPeriod,
      sites: this.calcs.payments.map(p => p.site),
    });
  }

  onNoClick(): void {
    this.dialogRef.close(null);
  }

  getPayments() {
    return this.calcs.payments;
  }

  getTotalPaid() {
    return this.calcs.payments
      .reduce((accumulator: number, value: any) => accumulator + (value.amount || 0), 0);
  }
}
